import { Loader } from '@googlemaps/js-api-loader'

export const googleMapsAvailable = !!process.env.GOOGLE_API_KEY

export const loader = new Loader({
  apiKey: process.env.GOOGLE_API_KEY,
  language: 'en',
})
